<div class="page-container">
  <div #mainHeader [ngClass]="{'hide-main-header' : hideHeader && !isCustom, 'hide-main-header-custom' : hideHeader && isCustom, 'hide-main-header-brixen' : hideHeader && isBrixen}" class="main-header">
    <app-main-header [forceSolidBgColor]="forceHeaderSolidBgColor"></app-main-header>
  </div>
  <div class="content" [style.margin-top.px]="contentMarginTop">
    <router-outlet></router-outlet>
    @if (isCustom) {
      <div style="height: 1px;"></div>
    }
    @if (areInPrRoutes) {
      <div style="height: 60px;"></div>
    }
  </div>
  @if (!isCustom) {
    <app-footer-one
      [ngStyle]="{'display': (!areInPrRoutes) || !isWebMobile ? 'block' : 'none'}">
    </app-footer-one>
  }
  @if (isCustom) {
    <app-custom-footer class="custom-footer"></app-custom-footer>
  }
</div>